export default __webpack_public_path__ + "591cad8bc4c796228d3674002d6bf77a.png";